import { render } from "./VUserSelectorSimple.vue?vue&type=template&id=0ab701a8&ts=true"
import script from "./VUserSelectorSimple.vue?vue&type=script&lang=ts"
export * from "./VUserSelectorSimple.vue?vue&type=script&lang=ts"

import "./VUserSelectorSimple.vue?vue&type=style&index=0&id=0ab701a8&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__